import { PERMISSION } from '../../auth/has-permission/has-permission-directive';

export const COMMUNICATION_PROVIDER_BASE_PATH = 'communication-provider';
export const BASE_COMMUNICATION_PROVIDER_PATH = '/communication-provider';

export const COMMUNICATION_PROVIDER_ROUTES_NAME = {
  LIST: {
    basePath: '/communication-provider',
    path: '',
    name: 'communication_provider_sub_menu.list',
    visible: true,
    expectedPermission: [PERMISSION.ALLOW_TO_VIEW_COMMUNICATION_PROVIDER_LIST]
  },
  CREATE: {
    basePath: '/communication-provider',
    path: 'create',
    name: 'communication_provider_sub_menu.create',
    visible: true,
    expectedPermission: [PERMISSION.ALLOW_TO_CREATE_COMMUNICATION_PROVIDER]
  },
  VIEW: {
    basePath: '/communication-provider',
    path: ':id/view',
    name: 'communication_provider_sub_menu.view',
    visible: false,
    expectedPermission: [PERMISSION.ALLOW_TO_VIEW_COMMUNICATION_PROVIDER_LIST]
  },
  EDIT: {
    basePath: '/communication-provider',
    path: ':id/edit',
    name: 'communication_provider_sub_menu.edit',
    visible: false,
    expectedPermission: [PERMISSION.ALLOW_TO_EDIT_COMMUNICATION_PROVIDER]
  }
};
